'use client';

import FeatureToggleContext from 'context/FeatureToggleContext';

export const ReactFeatureToggleProvider = ({ children }) => {
  return <FeatureToggleContext>{children}</FeatureToggleContext>
}

export default ReactFeatureToggleProvider;
